const options = {
  5: "bg-slate-300/5",
  10: "bg-slate-300/10",
  25: "bg-slate-300/25",
  50: "bg-slate-300/50",
  75: "bg-slate-300/75",
  90: "bg-slate-300/90",
  100: "bg-slate-300",
};

const from = {
  5: "from-slate-300/5",
  10: "from-slate-300/10",
  25: "from-slate-300/25",
  50: "from-slate-300/50",
  75: "from-slate-300/75",
  90: "from-slate-300/90",
  100: "from-slate-300",
};

export default function getBackgroundSlate300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
